/**
 * Make specific select boxes into custom select2 boxes.
 */
export default class Select {
  constructor() {
    let $selects = $('[data-select]');

    if ($selects.length) {
      $selects.each(function () {
        let $select = $(this);
        let $dropdownParent = $('body');
        let dataParent = $select.attr('data-parent');

        if (dataParent) {
          $dropdownParent = $(dataParent);
        }

        if ($select.attr('data-select') === 'default') {
          $select.select2({
            dropdownAutoWidth: true,
            minimumResultsForSearch: Infinity,
            width: '100%'
          });
        }

        if ($select.attr('data-select') === 'image-list') {
          $select.select2({
            dropdownParent: $dropdownParent,
            minimumResultsForSearch: Infinity,
            templateSelection: formatState,
            templateResult: formatState
          });
        }

        if ($select.attr('data-select') === 'image-list-country') {
          $select.select2({
            dropdownAutoWidth: true,
            minimumResultsForSearch: Infinity,
            templateSelection: formatStateCountry,
            templateResult: formatStateCountry
          });
        }

        if ($select.attr('data-select') === 'tags') {
          $select.select2({
            dropdownParent: $dropdownParent,
            tags: true
          });
        }
      });

      // Select all options
      $selects.on('select2:select', function (e: Event) {
        let $dropdown = $(this);
        let selectedValue = <string>$(e.currentTarget).val();
        let allOptions: any = [];

        if (selectedValue[0] === 'All') {
          $dropdown.find('option').each(function () {
            let value = $(this).val();
            allOptions.push(value);
          });

          $dropdown.val(allOptions).trigger('change');
        }
      });

      // Deselect all options
      $selects.on('select2:unselect', function (
        e: JQuery.Event
      ) {
        let $dropdown = $(this);
        // @ts-ignore
        let unselectedElement = e.params.data.id;

        if (unselectedElement === 'All') {
          $dropdown.val(null).trigger('change');
        }
      });

      $('select.js-select-link').on(
        'select2:select',
        (evt: Event) => {
          // @ts-ignore
          let $selectOption = $(evt.params.data.element);
          let optionURL = $selectOption.attr('data-url');

          if (optionURL) {
            window.location.href = optionURL;
          }
        }
      );

      let $select2 = $('.select2');
      $select2.closest('.InputOutsideContainer').addClass('js-select-is-active');
    }

    function formatState(state: any) {
      if (!state.id) {
        return state.text;
      }

      let $state = $(`<span>
                                <img src="/assets/img/flags/${state.element.value.toLowerCase()}.svg" class="select2-img" alt="${state.text
        }" />
                                ${state.text}
                            </span>`);

      return $state;
    }

    function formatStateCountry(state: any) {
      if (!state.id) {
        return state.text;
      }

      const id = state.element.id;

      if (!id) {
        return $(`<span>${state.text}</span>`);
      }

      let $state = $(`<span>
                                <img src="/assets/img/flags/${state.element.id.toLowerCase()}.svg" class="select2-img" alt="${state.text
        }"/>
                                ${state.text}
                            </span>`);

      return $state;
    }
  }
}
